module.exports = __webpack_public_path__ + "img/feedback-b.cb14d6c0.svg";